(() => {
  const STORAGE_TTL = 15 * 60 * 1000;
  const randomBetween = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  const getStorageKey = (element) => `spark-live-viewers:${element.dataset.viewersKey || window.location.pathname}`;

  const readStoredCount = (element, min, max) => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(getStorageKey(element)));
      const count = Number(stored?.count);
      const timestamp = Number(stored?.timestamp);
      const isRecent = Number.isFinite(timestamp) && Date.now() - timestamp < STORAGE_TTL;
      if (isRecent && Number.isFinite(count) && count >= min && count <= max) return count;
    } catch (error) {
      // Se o armazenamento estiver indisponível, mantém o contador a funcionar nesta página.
    }
    return null;
  };

  const storeCount = (element, count) => {
    try {
      window.localStorage.setItem(
        getStorageKey(element),
        JSON.stringify({ count, timestamp: Date.now() })
      );
    } catch (error) {
      // O armazenamento pode estar bloqueado em navegação privada.
    }
  };

  const updateViewerText = (element, count) => {
    const countElement = element.querySelector('[data-live-viewers-count]');
    const copyElement = element.querySelector('[data-live-viewers-copy]');
    if (!countElement || !copyElement) return;

    element.hidden = count === 0;
    const singular = count === 1;
    countElement.textContent = `${count} ${singular ? 'pessoa' : 'pessoas'}`;
    copyElement.textContent = singular
      ? 'está a ver este produto neste momento'
      : 'estão a ver este produto neste momento';
    element.dataset.viewersCount = count.toString();
    element.setAttribute(
      'aria-label',
      `${count} ${singular ? 'pessoa está' : 'pessoas estão'} a ver este produto neste momento`
    );
    storeCount(element, count);
  };

  const scheduleUpdate = (element, min, max) => {
    const delay = randomBetween(45, 90) * 1000;

    window.setTimeout(() => {
      if (!element.isConnected) return;

      const current = Number(element.dataset.viewersCount);
      let next;

      if (current <= min) {
        next = Math.min(min + 1, max);
      } else if (current >= max) {
        next = Math.max(max - 1, min);
      } else {
        next = current + (Math.random() < 0.5 ? -1 : 1);
      }

      updateViewerText(element, next);
      scheduleUpdate(element, min, max);
    }, delay);
  };

  const initLiveViewers = () => {
    document.querySelectorAll('[data-live-viewers]').forEach((element) => {
      if (element.dataset.liveViewersInitialized === 'true') return;

      const min = Number(element.dataset.viewersMin);
      const max = Number(element.dataset.viewersMax);
      if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) return;

      element.dataset.liveViewersInitialized = 'true';
      const storedCount = readStoredCount(element, min, max);
      const initial = storedCount ?? randomBetween(min, max);
      updateViewerText(element, initial);
      scheduleUpdate(element, min, max);
    });
  };

  document.addEventListener('DOMContentLoaded', initLiveViewers);
  document.addEventListener('shopify:section:load', initLiveViewers);
})();
